// Client-side store for the kiosk-scoped session token. Mirrors
// `portalSession` and `requestSession`. The token is issued by
// `kiosk/pair` once the device is claimed; subsequent `kiosk/*` calls
// authenticate with `Authorization: Bearer <token>`. The legacy
// `x-kiosk-id` header is gone — the wrapper resolves the kiosk
// identity from the session row.

const TOKEN_KEY = 'healthcom-schedule.kioskSession.token';
const EXPIRES_KEY = 'healthcom-schedule.kioskSession.expiresAt';

export const kioskSession = {
  getToken(): string | null {
    try {
      return sessionStorage.getItem(TOKEN_KEY);
    } catch {
      return null;
    }
  },

  setToken(token: string, expiresAt?: string) {
    try {
      sessionStorage.setItem(TOKEN_KEY, token);
      if (expiresAt) sessionStorage.setItem(EXPIRES_KEY, expiresAt);
    } catch {
      /* storage blocked */
    }
  },

  clear() {
    try {
      sessionStorage.removeItem(TOKEN_KEY);
      sessionStorage.removeItem(EXPIRES_KEY);
    } catch {
      /* ignore */
    }
  },

  isLikelyValid(): boolean {
    const token = this.getToken();

    if (!token) return false;

    let expiresAt: string | null = null;

    try {
      expiresAt = sessionStorage.getItem(EXPIRES_KEY);
    } catch {
      return true;
    }

    if (!expiresAt) return true;

    const expiresAtMs = Date.parse(expiresAt);

    return Number.isFinite(expiresAtMs) && expiresAtMs > Date.now();
  },
};
